// extracted by mini-css-extract-plugin
export var active = "_ho-7";
export var blink = "_ho-8";
export var dropDownSelector = "_ho-4";
export var dropDownWrapper = "_ho-3";
export var fakeCursor = "_ho-6";
export var fontSizeButton = "_ho-9";
export var formQuillEditor = "_ho-0";
export var pressed = "_ho-a";
export var qlBlank = "_ho-1";
export var textFormattingToolbar = "_ho-2";
export var textToolbarOption = "_ho-5";